export default __webpack_public_path__ + "static/media/1.84fcf2b1.jpg";